import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import filterFactory from 'react-bootstrap-table2-filter';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory, {
	PaginationProvider,
	PaginationListStandalone,
	PaginationTotalStandalone,
	SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../../../../App.css';
import Spinner from '../../../../Common/Spinner';
import TeamInitialisation from '../Datatables/ColumnDefinitions/TeamInitialisation';
import MultiTeamUpdateView from '../Datatables/MultiTeamUpdateView';
import { ADD_TOAST_MESSAGE } from '../../../../Redux/Enums/Contracts.Globals.Enums';
import { debounce, isInPast } from '../../../../utils';
import Styles from './ContractTeamDatatable.module.css';
import {
	onStartEdit,
	unhideRows,
	showRows,
	areRowsHidden,
	AmendmentInfo,
	UnhideButton,
	getEditState,
	setUnhideStatus,
	getUpdateRowEdit
} from './Helpers/RowEditHelpers';

class ContractTeamDatatable extends Component {
	constructor(props) {
		super(props);
		const { keyField } = props;
        this.state = {
            updateYear: '',
			pageNo: 1,
			pageSize: 10,
			keyField,
			inMultiEdit: false,
			inPreview: false,
			multiTeamData: {
					id: 1,
					templateId: 0,
					templateName: '',
					contractReleaseDate: '',
					contractEndDate: '',
					emailAddress: ''
			},
			hasMultiTeamData: false,
			editSearchMode: false,
			...getEditState({ hideIgnoreColumns: [0], searchRef: 'searchComponentRef' })
		};
		this.componentRef = React.createRef();

		this.handleTableChange = debounce(this.handleTableChange, 500);

		this.onStartEdit = onStartEdit.bind(this);
		this.unhideRows = unhideRows.bind(this);
		this.areRowsHidden = areRowsHidden.bind(this);
		this.getUpdateRowEdit = getUpdateRowEdit.bind(this);
		this.showRows = showRows.bind(this);
		this.setUnhideStatus = setUnhideStatus.bind(this);
	}

	componentDidUpdate() {
		const { fireShow, setFireShow, message = '', updated, selectedCount, amendments } = this.props;
		const { inMultiEdit, hasMultiTeamData } = this.state;

		if (inMultiEdit && message.toLowerCase().indexOf('success') > -1 && updated.length === 0) {
			this.setState({ inMultiEdit: false });
		}

		if (selectedCount === 0 && hasMultiTeamData) {
			this.clearMultiEdit();
		}

		if (amendments === 0) {
			this.removePreview();
		}

		if (fireShow) {
			this.showRows();
			setFireShow(false);
		}

		this.setUnhideStatus();
	}

	clearMultiEdit = () => {
		const initMultiData = {
			id: 1,
			templateId: 0,
			templateName: '',
			contractReleaseDate: '',
			contractEndDate: '',
			emailAddress: ''
		};
		this.setState({ 
			multiTeamData: initMultiData, 
			hasMultiTeamData: false 
		});
	};

	componentWillUnmount = () => this.props.handleClearUpdates();

	handleTableChange = async (type, state) => {
		let { sortOrder, sortField, page, sizePerPage } = state;
		let { updated, year, contractTypes, teamIds, templateId, contractStatus, markingMethod, inputTitle, inputMarkingTeamCode, handleGetData, setPageDetails, previewUpdate, isGroupUpdaterFilter } = this.props;
		const searchText = '', exportData = false, isRefine = false, isGroupUpdater = false;
		sortOrder = sortOrder ? sortOrder : 'asc';
		sortField = sortField ? sortField : 'title';
		page = type === 'search' ? 1 : page;
		const query = {
			sortOrder,
			sortField,
			page,
			sizePerPage,
			searchText,
			flagExportData: false
		};
		await handleGetData(contractTypes, year, query, updated, exportData, teamIds, isRefine, templateId, contractStatus, markingMethod, inputTitle, inputMarkingTeamCode, isGroupUpdater, previewUpdate, isGroupUpdaterFilter);

		const updateRowEdit = this.getUpdateRowEdit(searchText);
		this.setState({ ...this.state, pageNo: page, pageSize: sizePerPage, ...updateRowEdit });
		this.componentRef.scrollIntoView({ behavior: 'smooth' });
		setPageDetails && setPageDetails(sizePerPage);
	};

	handleGetExportData = async props => {
		const exportData = true, isRefine = false, updatedTeam = [], isGroupUpdater = false, previewUpdate = [];
		const { year, contractTypes, handleGetData, teamIds, templateId, contractStatus, markingMethod, inputTitle, inputMarkingTeamCode, isGroupUpdaterFilter } = this.props;
		const query = {
			sortOrder: 'asc',
			sortField: 'title',
			page: 0,
			sizePerPage: 0,
			searchText: '',
			flagExportData: true
		};
		await handleGetData(contractTypes, year, query, updatedTeam, exportData, teamIds, isRefine, templateId, contractStatus, markingMethod, inputTitle, inputMarkingTeamCode, isGroupUpdater, previewUpdate, isGroupUpdaterFilter);
		props.onExport(this.props.all_data);
	};

	multiEditClick = () => {
		const { inMultiEdit } = this.state;
		this.setState({inMultiEdit: !inMultiEdit });
	};

	previewClick = () => {
		const { inPreview } = this.state;
		this.setState({ inPreview: !inPreview });
	}

	displayWarning = message => {
		const { dispatch } = this.props;
		dispatch({ type: ADD_TOAST_MESSAGE, payload: { severity: 'warning', message } });
	};

	getEditability = (row, column) => {
		const { inPreview } = this.state;
		if (inPreview) {
			return {
				editable: false,
				message: 'To edit please exit preview'
			};
		}

		return this.getFieldEditability(row, column);
	};

	getFieldEditability = (row, column) => {
		let editable = true;
		let message = '';
		const { editableReleasedTeams, editStatuses, keyField, lockedReleasedTeams } = this.props;
		const rowKey = row[keyField];
		if (editableReleasedTeams.includes(rowKey)) {
			const { markingMethodEdit, markingTemplateEdit } = editStatuses[rowKey];
			if (column.dataField === 'markingMethodCurrentYear' && !markingMethodEdit) {
				editable = false;
				message = 'Marking Method is not editable as it has not been amended';
			}
			if (column.dataField === 'templateName' && !markingTemplateEdit) {
				editable = false;
				message = 'Marking Template is not editable as Marking Type has not been amended';
			}
			if (column.dataField !== 'markingMethodCurrentYear' && column.dataField !== 'templateName') {
				editable = false;
				message = `${column.text} is not editable as past the contract release date`;
			}
		}
		let rowDate = new Date(row.contractReleaseDate).getTime();
		let todaysDate = new Date().getTime();
		var result = todaysDate > rowDate;
		if (result) {
			editable = true;
		} else if (lockedReleasedTeams.includes(rowKey)) {
			editable = false;
			message = `${row.title} is not editable as past the contract release date and no outstanding amendment`;
		}
		return { editable, message };
	};

	checkEditability = (oldValue, newValue, row, column, done) => {
		const { editable, message } = this.getEditability(row, column);
		if (!editable) {
			this.displayWarning(message);
		}
		setTimeout(() => (editable ? done() : done(false)), 100);
		return { async: true };
	};

	checkUpdate = (oldValue, newValue, row, column) => {
		const { handleAddUpdates, updated, dataCopy } = this.props;

		const isReleased = isInPast(row.contractReleaseDate);
		const { editable } = this.getEditability(row, column);

		if ( isReleased && !editable ) {
			this.displayWarning('Cannot update a team with Release Date in the past.');
			return;
		}

		if (column.dataField === 'displayStatus') {
			if (newValue === '') {
				if (row.hidStatus === 'Ready To Issue' && oldValue !== 'Ready To Issue') {
					row.contractReleaseDate = row.hidReleaseDate;
					row.contractEndDate = row.hidEndDate;
				}
				row.displayStatus = row.hidStatus;
			} else if (oldValue === 'Ready To Issue') {
				row.contractReleaseDate = '';
				row.contractEndDate = '';
			}
		}

		const isInOriginalData = dataCopy.find(rowCopy => isEqual(rowCopy, row));

		if (!isInOriginalData) {
			const _row = cloneDeep(row);
			handleAddUpdates(column.dataField, newValue, _row, updated);
		} else {
			const { removeUpdate, keyField } = this.props;
			removeUpdate(keyField, row[keyField], updated);
		}
	};

	multiTeamDataChange = () => {
		const initMultiData = {
			id: 1,
			templateId: 0,
			templateName: '',
			contractReleaseDate: '',
			contractEndDate: '',
			emailAddress: ''
		};
		const { multiTeamData } = this.state;
		const hasMultiTeamData = !isEqual(multiTeamData, initMultiData);
		this.setState({ hasMultiTeamData });
	};

	getMultiEditChanges = ({id, templateId, ...rest}) => {
		const _multiTeamData = {};
		if (templateId !== 0) {
			_multiTeamData.templateId = templateId;
		}
		Object.keys(rest).forEach(key => {
			if (rest[key] !== '') {
				_multiTeamData[key] = rest[key];
			}
		});
		return _multiTeamData;
	};

	applyMultiEdit = () => {
		const { handleApplyMultiTeamUpdate, updated, data } = this.props;
		const { multiTeamData } = this.state;
		const _multiTeamData = this.getMultiEditChanges(multiTeamData);
		
		handleApplyMultiTeamUpdate(data, updated, _multiTeamData);
		this.clearMultiEdit();
	};

	removeAllEdits = () => {
		const { handleRemoveAllEdits } = this.props;
		handleRemoveAllEdits();
		this.clearMultiEdit();
	};

	removePreview = () => {
		const { inPreview } = this.state;
		if (inPreview) {
			this.setState({inPreview: false});
		}
	};

	render() {
		const {
			pageNo,
			pageSize,
			hiddenRows,
			inMultiEdit,
			inPreview,
			multiTeamData,
			hasMultiTeamData
		} = this.state;

		const { lockedReleasedTeams, 
			updated,
			total, 
			data,
			isDataAPICallCompleted, 
			templateData, 
			keyField, 
			contractTypes,
			amendments,
			selectedCount
		} = this.props;

		const CustomCsvButton = props => (
			<button
				className="react-bs-table-csv-btn btn btn-default btn-primary"
				style={{ height: '45px', width: '200px' }}
				onClick={() => this.handleGetExportData(props)}
			>
				Export CSV
			</button>
		);

		const numberOfUpdates = updated.length;
		const showApply = hasMultiTeamData && selectedCount > 0;
		const hasAmendments = amendments > 0 || selectedCount > 0;
		const viewData = inPreview ? updated : data;
        const showPagination = !this.areRowsHidden() && !inPreview;

		const columns = TeamInitialisation(templateData, this.onStartEdit);

		let btnEditDisable = ((updated.length > 0 && updated.find(x => x.selectTeam === 'Y') !== undefined) || inMultiEdit) ? false : true;

		return (
			<div>
				<div ref={el => (this.componentRef = el)} className={inMultiEdit ? Styles.hidden : Styles.visible }>
						<PaginationProvider
							pagination={paginationFactory({
								custom: true,
								totalSize: total,
								page: pageNo,
								sizePerPage: pageSize,
								showTotal: true,
								withFirstAndLast: true,
								alwaysShowAllBtns: true
							})}
							keyField={keyField}
							columns={columns}
							data={viewData}
						>
							{({ paginationProps, paginationTableProps }) => (
								<ToolkitProvider
									keyField={keyField}
									columns={columns}
									data={viewData}
									exportCSV={{
										fileName: `contract_Management_${contractTypes.join('_')}.csv`,
										separator: ','
									}}
								>
									{toolkitProps => {
										return (
											<div className={`container-fluid ${this.areRowsHidden() ? Styles.container : ''}`}>
												{showPagination && (
													<div className={Styles.pageNumberListOuter}>
														<div className={Styles.pageNumberSection}></div>
														<div className={Styles.pageNumberList}><PaginationListStandalone {...paginationProps} /></div>
														<div className={Styles.pageTotalDetails}>
															<PaginationTotalStandalone dataSize={total} {...paginationProps} />
															<SizePerPageDropdownStandalone {...paginationProps} />														
														</div>
													</div>
												)}

												<BootstrapTable
													classes={'table table-primary table-striped table-sm table-responsive-md'}
													{...toolkitProps.baseProps}
													{...paginationTableProps}
													remote={{
														pagination: true
													}}
													onTableChange={this.handleTableChange}
													filter={filterFactory()}
													bootstrap4
													striped
													condensed
													hover
													size="sm"
													hiddenRows={hiddenRows}
													cellEdit={cellEditFactory({
														mode: 'click',
														blurToSave: true,
														autoSelectText: true,
														timeToCloseMessage: 10000,
														nonEditableRows: () => lockedReleasedTeams,
														onStartEdit: this.onStartEdit,
														beforeSaveCell: (oldValue, newValue, row, column, done) => this.checkEditability(oldValue, newValue, row, column, done),
														afterSaveCell: this.checkUpdate
													})}
												/>
												{!isDataAPICallCompleted && <Spinner />}

												{showPagination && (
													<div className={Styles.pageNumberListOuter}>
														<div className={Styles.pageNumberSection}><CustomCsvButton {...toolkitProps.csvProps} /></div>
														<div className={Styles.pageNumberList}><PaginationListStandalone {...paginationProps} /></div>
														<div className={Styles.pageTotalDetails}>
															<PaginationTotalStandalone dataSize={total} {...paginationProps} />
															<SizePerPageDropdownStandalone {...paginationProps} />															
														</div>
													</div>
												)}
											</div>
										);
									}}
								</ToolkitProvider>
							)}
						</PaginationProvider>
				</div>
				
				<div className={`${Styles.multiedit} ${inMultiEdit ? Styles.visible : Styles.hidden}`} >
					<MultiTeamUpdateView
						multiTeamData={[multiTeamData]}
						templateData={templateData}
						updated={updated}
						multiTeamDataChange={this.multiTeamDataChange}
					/>
				</div>

				<AmendmentInfo count={amendments} />
				<div className="SelectButtonCell">
					{this.areRowsHidden() ? (
						<UnhideButton onClick={this.unhideRows} numberOfUpdates={numberOfUpdates} />
					) : (
						<>
							{hasAmendments  && <button
								style={{ height: '45px', width: '150px' }}
								onClick={this.previewClick}
								className={`react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm`}
							>
								{ inPreview ? 'Remove Preview' : 'Show Preview'}
							</button>}							
							
							{hasAmendments  && <button
								style={{ height: '45px', width: '150px' }}
								onClick={this.removeAllEdits}
								className={`react-bs-table-csv-btn btn btn-default btn btn-secondary btn-sm`}
							>
								Remove All Edits
							</button>}

							{showApply  && <button
								disabled={btnEditDisable}
								style={{ height: '45px', width: '225px' }}
								onClick={this.applyMultiEdit}
								className={`react-bs-table-csv-btn btn btn-default btn btn-link btn-sm ${Styles.apply}`}
							>
								Apply Multi Edit To {`${selectedCount} ${selectedCount > 1 ? 'Rows' : 'Row'}`}
							</button>}
						</>
					)}
				</div>
			</div>
		);
	}
}

export default ContractTeamDatatable;
